import React from "react";
import logo from "../img/logo.webp";
import { Nav, Navbar } from "react-bootstrap";
import styled from "styled-components";

export default (props) => {
  return (
    <Styles>
      <Navbar
        className="color-nav navbar-info"
        collapseOnSelect
        expand="md"
        fixed="top"
      >
        <Navbar.Brand href="/" className="nav-brand">
          <img
            alt="logo"
            src={logo}
            type="image/webp"
            className="d-inline-block align-top logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="nav-title-left" activeKey={window.location.pathname}>
            <Nav.Link href="/">
              <h6>Home</h6>
            </Nav.Link>
            <Nav.Link href="/profile">
              <h6>Profile</h6>
            </Nav.Link>
          </Nav>
          <Nav className="nav-title-right" activeKey={window.location.pathname}>
            <Nav.Link href="/blog">
              <h6>Blog</h6>
            </Nav.Link>
            <Nav.Link href="/contact">
              <h6>Contact</h6>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </Styles>
  );
};

const Styles = styled.div`
  .color-nav {
    background-color: #ffffff;
    height: 12%;
  }

  .navbar-light .navbar-nav .nav-link {
    color: #87c4c1;
  }

  .navbar-light .navbar-nav .nav-link.active {
    color: #0097a7;
  }

  .navbar-light .navbar-nav .nav-link:hover {
    color: #808080;
  }

  .nav-title-left {
    position: relative;
    left: 30%;
  }
  .nav-title-right {
    position: absolute;
    left: 60%;
  }
  .nav-brand {
    position: relative;
    left: 50%;
    display: block;
  }
  .logo {
    width: 80px;
    height: 80px;
  }

  @media (min-width: 2200px) {
    h6 {
      font-size: 1.4rem;
    }
    .logo {
      width: 120px;
      height: 120px;
    }
  }

  @media (max-width: 768px) {
    .nav-title-left {
      left: 20%;
    }
    .nav-title-right {
      left: 62%;
    }
  }

  @media (max-width: 736px) {
    .nav-title-left,
    .nav-title-right {
      position: relative;
      left: 0%;
    }
    .nav-brand {
      left: 0%;
    }
    #responsive-navbar-nav a {
      padding: 2% 2% 2% 3%;
    }
    .logo {
      width: 60px;
      height: 60px;
    }
    .navbar-collapse {
      background-color: white;
      margin-top: -15px;
      margin-right: -16px;
      margin-left: -16px;
    }
    .color-nav {
      height: 20%;
    }
  }

  @media (max-width: 567px) {
    .nav-title-left,
    .nav-title-right {
      position: relative;
      left: 0%;
    }
    .nav-brand {
      left: 0%;
    }
    #responsive-navbar-nav a {
      padding: 2% 2% 2% 3%;
    }
    .logo {
      width: 70px;
      height: 70px;
    }
    .color-nav {
      height: 13%;
    }
  }
`;
